<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="expire"
        :label="$t('Date expiration')"
        clearable
        @click:clear="expire = null"
        persistent-hint
        @blur="date = expire"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="expire"
      no-title
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: "DatePicker",
  data: function() {
    return {
      expire: null,
      menu: false
    };
  },
  props: {
    value: null
  },
  mounted() {
    this.expire = this.value;
  },
  watch: {
    expire: function(val) {
      this.$emit("input", val);
    },
    value: function(val) {
      this.expire = val;
    }
  }
};
</script>
